import React, { useState } from "react";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../Utils/renderField/renderReadField";
import { ResumenProductosMetrica } from "./ResumenProductosMetrica";

const defaultValues = {
    peso: 0,
    pacas: 0,
};

export const MetricasPaletizacion = (props) => {
    const { metricasPaletizacion, mode } = props;
    const objMetricas =
        mode === "sin_paletizar"
            ? metricasPaletizacion.sin_paletizar
            : metricasPaletizacion.paletizado;
    const headerText =
        mode === "sin_paletizar"
            ? "Producción Sin Paletizar"
            : "Producción Paletizada";

    const [tooltipActivo, setTooltipActivo] = useState(null);

    const {
        turno_actual = defaultValues,
        turno_anterior = defaultValues,
        reclasificacion = defaultValues,
        productos = [],
        sobrantes = [],
    } = objMetricas || {};

    const totalPesos =
        turno_actual.peso + turno_anterior.peso + reclasificacion.peso;

    // los sobrantes se manejan por producto pero solo aportan a
    // reclasificación: se normalizan a la misma forma que "productos" (con
    // turno_actual/turno_anterior en 0) para reutilizar el mismo resumen
    // con tooltip
    const productosConSobrantes = [
        ...productos,
        ...sobrantes.map((sobrante) => ({
            producto_id: `sobrante-${sobrante.producto_id}`,
            producto_nombre: `${sobrante.producto_nombre} (Sobrante)`,
            turno_actual: { pacas: 0, peso: 0 },
            turno_anterior: { pacas: 0, peso: 0 },
            reclasificacion: {
                // solo pacas completas: una fracción (ej. 34.99 kg) no forma
                // una paca; el peso sí muestra el saldo real en kg
                pacas: Math.floor(Number(sobrante.pacas || 0)),
                peso: sobrante.peso,
            },
        })),
    ];

    return (
        <React.Fragment>
            <div
                className="py-3 px-3 mt-3 mb-4"
                style={{ backgroundColor: "#ebebeb", borderRadius: "1rem" }}
            >
                <h5 className="text-nowrap text-xsm bold">
                    {headerText} (
                    <RenderKilogramo value={totalPesos || 0} decimals={3} />)
                </h5>
                <div className="d-flex justify-content-between gap-1rem flex-wrap">
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Peso turno actual:
                        </label>
                        <h4 className="text-nowrap">
                            <RenderKilogramo
                                value={turno_actual.peso}
                                decimals={3}
                            />{" "}
                            / <RenderNumber value={turno_actual.pacas} /> pacas
                        </h4>
                        <ResumenProductosMetrica
                            id="turno_actual"
                            tooltipActivo={tooltipActivo}
                            setTooltipActivo={setTooltipActivo}
                            productos={productosConSobrantes}
                            tipo="turno_actual"
                            titulo="Turno actual"
                        />
                    </div>
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Peso turno anterior:
                        </label>
                        <h4 className="text-nowrap">
                            <RenderKilogramo
                                value={turno_anterior.peso}
                                decimals={3}
                            />{" "}
                            / <RenderNumber value={turno_anterior.pacas} /> pacas
                        </h4>
                        <ResumenProductosMetrica
                            id="turno_anterior"
                            tooltipActivo={tooltipActivo}
                            setTooltipActivo={setTooltipActivo}
                            productos={productosConSobrantes}
                            tipo="turno_anterior"
                            titulo="Turno anterior"
                        />
                    </div>
                    <div>
                        <label className="text-nowrap mb-1 pl-0 font-weight-400">
                            Peso reclasificación:
                        </label>
                        <h4 className="text-nowrap">
                            <RenderKilogramo
                                value={reclasificacion.peso}
                                decimals={3}
                            />{" "}
                            / <RenderNumber value={reclasificacion.pacas} /> pacas
                        </h4>
                        <ResumenProductosMetrica
                            id="reclasificacion"
                            tooltipActivo={tooltipActivo}
                            setTooltipActivo={setTooltipActivo}
                            productos={productosConSobrantes}
                            tipo="reclasificacion"
                            titulo="Reclasificación"
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};
